import { render, staticRenderFns } from "./gmwechatconfig.vue?vue&type=template&id=69ffb9a2&scoped=true&"
import script from "./gmwechatconfig.vue?vue&type=script&lang=js&"
export * from "./gmwechatconfig.vue?vue&type=script&lang=js&"
import style1 from "./gmwechatconfig.vue?vue&type=style&index=1&id=69ffb9a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ffb9a2",
  null
  
)

export default component.exports